import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=706bb060&scoped=true"
import script from "./ResumeCard.vue?vue&type=script&lang=js"
export * from "./ResumeCard.vue?vue&type=script&lang=js"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=706bb060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bb060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VIcon})
